<template>
  <VuelidateField :validation="v$.featureId">
    <template #default="{ error, state }">
      <FieldWrapper for="feature-select" :label="t('Reviews.agency.edit.feature.label').toString()" :error="error" class="mb-8">
        <template #default="{ id: inputId }">
          <SelectField
            :id="inputId"
            v-model="v$.featureId.$model"
            :placeholder="t('Reviews.agency.edit.feature.placeholder').toString()"
            :state="state"
          >
            <option v-for="option in options" :key="option.id" :value="option.id">{{ option.name }}</option>
          </SelectField>
        </template>
      </FieldWrapper>
    </template>
  </VuelidateField>
</template>

<script setup lang="ts">
import { FieldWrapper, SelectField } from '@ramp106/omrjs-core-ui'
import { useVuelidate } from '@vuelidate/core'
import { computed, reactive, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import { required, uniqueArrayElement } from '@/services/validators'
import VuelidateField from '@/ui/VuelidateField.vue'

import type { FeatureFormData } from './types'

const props = defineProps<{
  modelValue: FeatureFormData
  options: { name: string; id: string }[]
  selectedFeatures: string[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: FeatureFormData): void
}>()

const { t } = useI18n()

const formData = reactive<FeatureFormData>({
  ...props.modelValue,
})

const rules = computed(() => ({
  featureId: { required, uniqueArrayElement: uniqueArrayElement(() => props.selectedFeatures || []) },
}))

const v$ = useVuelidate(rules, formData)

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal?.featureId) {
      formData.featureId = newVal.featureId
    }
  },
)

watch(
  () => formData,
  () => {
    emit('update:modelValue', formData)
  },
  { deep: true },
)
</script>
